import { useSelector } from 'react-redux';
import { selectAccessLevel } from '../slices/subscriptions/subscriptionsSlice';
import { examsSelectors } from '../slices/exams/examsSlice';
import { SubscriptionAccess } from '../types/Subscription';

const ACCESS_HIERARCHY = {
  [SubscriptionAccess.FREE]: 0,
  [SubscriptionAccess.PRE_CLINICAL]: 1,
  [SubscriptionAccess.STEP_SHELF]: 2,
};

export const useAccess = () => {
  const primaryExamAccessLevel = useSelector(
    examsSelectors.selectPrimaryExamAccessLevel
  );
  const userAccessLevel = useSelector(selectAccessLevel);

  const isGated = () => {
    // Free users are always gated
    if (userAccessLevel === SubscriptionAccess.FREE) return true;

    // Check if user's access level is sufficient for exam level
    return (
      ACCESS_HIERARCHY[userAccessLevel] <
      ACCESS_HIERARCHY[primaryExamAccessLevel]
    );
  };

  return {
    isGated,
  };
};
